import Vue from 'vue'
// 导入moment
import moment from 'moment'

// 注册过滤器
Vue.filter('formatTime',value=>{
    return moment(value).format('YYYY/MM/DD HH:mm:ss')
})


// WEBPACK FOOTER //
// ./src/filter/index.js